import "./style.scss";
import { FC, useState } from "react";
import { IRowData } from "@/src/types/applicationOnline";
import BtnDefault from "@/src/components/BtnDefault/BtnDefault";
import Arrow from "@/src/assets/sidebar/Arrow.png";
import { applicationPageSvgConst } from "@/src/svg/applicationsPage/APPopUp/APPopUpSvgExport";
import { onlineApplicationsPopUpTabs } from "@/src/constants/applicationOnlineConsts";
import GeneralInformation from "./APPopUpTabs/GeneralInformation/GeneralInformation";
import Documents from "./APPopUpTabs/Documents/Documents";

interface IAPPopUp {
  isApPopUpFullName: boolean;
  currentDataPopUp: IRowData | undefined;
  setIsApPopUpFullName: React.Dispatch<React.SetStateAction<boolean>>;
}

const APPopUp: FC<IAPPopUp> = ({ isApPopUpFullName, currentDataPopUp, setIsApPopUpFullName }) => {
  console.log(currentDataPopUp, "currentDataPopUp");
  const [currentTabID, setCurrentTabID] = useState<string>("general-information");
  const [editor, setEditor] = useState<boolean>(false);

  const [currentEditorObj, setCurrentEditorObj] = useState<IRowData | undefined>();
  const [editorDraft, setEditorDraft] = useState<IRowData | undefined>();

  const handleStartEditorEvent = () => {
    setEditorDraft(currentEditorObj ?? currentDataPopUp);
    setEditor(true);
  };

  const handleEditorOkEvent = () => {
    setCurrentEditorObj(editorDraft);
    setEditor(false);
    console.log("Saved object:", editorDraft);
  };

  const handleEditorCloseEvent = () => {
    setEditorDraft(currentEditorObj ?? currentDataPopUp);
    setEditor(false);
  };

  return (
    <div className={`applications-page-popUp ${isApPopUpFullName ? "show" : ""}`}>
      <div className="applications-page-popUp-header">
        <div className="applications-page-popUp-header-top">
          <div className="applications-page-popUp-header-top-title">
            <p>Full Information</p>
          </div>
          <div className="applications-page-popUp-header-top-buttons">
            {editor ? (
              <>
                <BtnDefault onlyIcon={true} onClick={() => handleEditorOkEvent()}>
                  <applicationPageSvgConst.EditorOkSvg />
                </BtnDefault>
                <BtnDefault onlyIcon={true} onClick={() => handleEditorCloseEvent()}>
                  <applicationPageSvgConst.EditorCloseSvg />
                </BtnDefault>
              </>
            ) : (
              <>
                <BtnDefault onlyIcon={true}>
                  <applicationPageSvgConst.PreviewSvg />
                </BtnDefault>
                <BtnDefault onlyIcon={true} onClick={() => handleStartEditorEvent()}>
                  <applicationPageSvgConst.CommentsSvg />
                </BtnDefault>
                <BtnDefault onlyIcon={true}>
                  <applicationPageSvgConst.InfoSvg />
                </BtnDefault>
                <BtnDefault onlyIcon={true}>
                  <applicationPageSvgConst.DownloadSvg />
                </BtnDefault>
                <BtnDefault onlyIcon={true}>
                  <applicationPageSvgConst.UnreadSvg />
                </BtnDefault>
                <BtnDefault onlyIcon={true}>
                  <applicationPageSvgConst.AdmissionForwardSvg />
                </BtnDefault>
                <BtnDefault onlyIcon={true}>
                  <applicationPageSvgConst.TasksSvg />
                </BtnDefault>
                <BtnDefault onlyIcon={true}>
                  <applicationPageSvgConst.MoveSvg />
                </BtnDefault>
                <BtnDefault onlyIcon={true}>
                  <applicationPageSvgConst.DeleteSvg />
                </BtnDefault>
                <div className="applications-page-popUp-header-top-button close">
                  <BtnDefault onlyIcon={true} onClick={() => setIsApPopUpFullName(false)}>
                    <img src={Arrow} alt="Arrow" />
                  </BtnDefault>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="applications-page-popUp-header-tabs">
          {onlineApplicationsPopUpTabs.map((tab, index) => (
            <div
              className={`applications-page-popUp-header-tabs-tab ${currentTabID === tab.id ? "active" : ""}`}
              key={index}
              onClick={() => setCurrentTabID(tab.id)}
            >
              <p>{tab.title}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="applications-page-popUp-body">
        {currentTabID === "general-information" && (
          <GeneralInformation
            viewData={currentEditorObj ?? currentDataPopUp}
            draftData={editorDraft}
            editor={editor}
            setEditorDraft={setEditorDraft}
          />
        )}
        {currentTabID === "documents" && <Documents />}
      </div>
      <div className="applications-page-popUp-footer">
        <div className="applications-page-popUp-footer-title">
          <p>Executor</p>
        </div>
        <div className="applications-page-popUp-footer-users">
          <div className="applications-page-popUp-footer-users-user">
            <applicationPageSvgConst.UnknownUserSvg />
            <div className="applications-page-popUp-footer-users-user-status">
              <applicationPageSvgConst.StatusRedSvg />
            </div>
          </div>
          <div className="applications-page-popUp-footer-users-user">
            <applicationPageSvgConst.UnknownUserSvg />
            <div className="applications-page-popUp-footer-users-user-status">
              <applicationPageSvgConst.StatusRedSvg />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default APPopUp;
